module.exports = __webpack_public_path__ + "img/samo.136ea584.png";